import { AlertSeverityEnum } from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import DeleteIcon from '@mui/icons-material/Delete';
import { Alert, Button, Grid, IconButton } from '@mui/material';
import React, { ChangeEvent, useEffect, useRef, useState } from 'react';
import UploadIcon from '@mui/icons-material/Upload';
interface ImageUploadProps {
  idInput: string;
  buttonText: string;
  setSelectedImage: React.Dispatch<React.SetStateAction<File | null>>;
  selectedImage: File | null;
  imageUrl?: string;
  enablePreview?: boolean;
  customPrevieContentNode?: React.ReactNode;
  accept?: string;
  onClickTrash?: () => void;
  onRemoveImage?: (imageUrl?: any, selectedImage?: any) => void;
  onChangeImage?: (imageUrl?: any, selectedImage?: any) => void;
  disabledInput?: boolean;
  permiteImagen?: boolean;
  showCustomPreviewEdit?: boolean;
  customPreviewEditNode?: React.ReactNode;
  endIcon?: React.ReactNode;
  canDelete?: boolean;
  tiposPermitidos?: string[]
}
//const tiposPermitidos = ["application/pdf", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"];
const CargarDocumentoSoluccionCosteada: React.FC<ImageUploadProps> = ({
  idInput,
  buttonText,
  setSelectedImage,
  selectedImage,
  imageUrl = '',
  accept = ".pdf, .xlsx, .xls,.xml",
  onChangeImage,
  disabledInput = false,
  permiteImagen = false,
  tiposPermitidos = ["application/pdf", "image/*", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel", "application/xml "]
}) => {
  const [, setImagenUrlAux] = useState<string>(imageUrl);

  const fileInputRef = useRef<HTMLInputElement>(null);
  const setAlert = useUiStore(s => s.setAlert)
  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {

    const file = event.target.files?.[0];

    console.log('file', file)
    if (!file) return;

    if (permiteImagen && file) {
      const selectedFile = file;
      setSelectedImage(selectedFile);
      return
    }
    if (file && tiposPermitidos.includes(file.type)) {
      const selectedFile = file;
      setSelectedImage(selectedFile);
      return;
    }
    setAlert(true, `Tipo de datos permitidos ${accept} y tengo ${file!.type}`, AlertSeverityEnum.warning);
  };
  useEffect(() => {
    setImagenUrlAux(imageUrl);
  }, [imageUrl])

  return (
    <Grid item container spacing={1} xs={12} justifyContent={'start'} alignItems={'center'}>
      <Grid item xs={12}>
        <input
          type="file"
          accept={accept}
          ref={fileInputRef}
          onChange={e => {
            if (disabledInput) return;
            handleFileChange(e);
            onChangeImage && onChangeImage(imageUrl, selectedImage);
          }}
          style={{ display: 'none' }}
          id={'image-upload-input-' + idInput}
          disabled={disabledInput}
        />
        <label htmlFor={'image-upload-input-' + idInput}>
          <Button
            fullWidth
            variant="outlined"
            component="span"
            size="medium"
            startIcon={<UploadIcon />}
          >
            {buttonText}
          </Button>
        </label>
      </Grid>
      {
        selectedImage != null && (
          <>
            <Grid item xs={12}>
              <Alert severity="success"
                action={
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => {
                      setSelectedImage(null)
                      if (fileInputRef.current) {
                        fileInputRef.current.value = '';
                      }
                    }}
                  >
                    <DeleteIcon fontSize="inherit" />
                  </IconButton>
                }
              >
                {`Archivo "${selectedImage.name}" cargado correctamente.`}
              </Alert>
            </Grid>
          </>
        )
      }
    </Grid>
  )
};
export default CargarDocumentoSoluccionCosteada;